import { useContext } from 'react'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'
import { UserPermissionsContext } from 'app/hooks/useUserPermission'
import { useAuthStore, useFeatureToggleStore } from 'app/stores/StoreContext'
import type { UserJson } from 'app/types/entities'
import type { NavGate } from 'app/types/navigation'
import { hasRole } from 'app/utils'

/** Call from an `observer()` component: toggles and products are MobX state. */
export function useNavGate(user: UserJson): NavGate | undefined {
  const { permissions } = useContext(UserPermissionsContext)
  const checkPermission = useCheckPermission()
  const featureToggleStore = useFeatureToggleStore()
  const { products } = useAuthStore()
  const staffV2Enabled = useFeatureToggle(`staff-v2`)

  // Returning nothing until permissions load prevents a flash of pages the user cannot open.
  if (user.type !== `super` && permissions === undefined) return undefined

  return {
    isSuperUser: user.type === `super`,
    products,
    inWorkspace: user.workspaceId != null,
    staffV2Enabled,
    checkPermission,
    isFeatureEnabled: (name) => featureToggleStore.isEnabled(name),
    hasRole: (role) => hasRole(user, role),
  }
}
